import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import Section from "../../components/section";
import React from "react";
import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Plus from "../../components/svg/plus";
import Label from "../../components/label";
import Trash from "../../components/svg/trash";
import ImageUploader from "../../components/upload-image";
import Button from "../../components/Buttons";
import { FormikDropdown } from "../../components/dropdown";
import { FormikTextarea } from "../../components/textarea";

export default function AddUser() {
  return (
    <div className="p-3 bg-[#fffbf4] ">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const {
    initialValues,
    handleTrainerAdd,
    handleTrainerDelete,
    trainersArrayRef,
    handleSubmit,
    handleBeliefAdd,
    handleBeliefDelete,
    monialsRef,
    getFaqQuery,
    believesArrayRef,
  } = usePageProvider();

  return (
    <Section>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0" className="mt-5">
              <Accordion.Item eventKey="5" className="w-[100%]  ml-[1rem] ">
                <Accordion.Header>SEO META</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Meta Title" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_title" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Meta Keywords" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_keyword" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Meta Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_desc" rootClassName="w-full" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>Header</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.heading" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Alt Tag" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.alt_tag" rootClassName="w-full" />
                    </div>
                  </div>
                  <div className="flex flex-col mt-2">
                    <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                    <FormikTextarea name="header.description" rootClassName="w-full" as="textarea" />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2">
                    <div className="flex flex-col">
                      <Label label="Desktop Banner" className="mb-2 text-black text-[15px] font-semibold" />
                      <ImageUploader
                        className="w-full"
                        title="image"
                        name="header.banner.desktop_url"
                        imageUrl={values?.header?.banner?.desktop_url}
                        onChange={(res) => {
                          setFieldValue(`header.banner.desktop_url`, res?.data?.file_url);
                        }}
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Mobile Banner" className="mb-2 text-black text-[15px] font-semibold" />
                      <ImageUploader
                        className="w-full"
                        title="image"
                        name="header.banner.mobile_url"
                        imageUrl={values?.header?.banner?.mobile_url}
                        onChange={(res) => {
                          setFieldValue(`header.banner.mobile_url`, res?.data?.file_url);
                        }}
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>Empower Section</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1  gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="section_empower.heading" rootClassName="w-full" />
                    </div>
                  </div>
                  <div className="flex flex-col mt-2">
                    <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                    <FormikTextarea name="section_empower.description" rootClassName="w-full" as="textarea" />
                  </div>

                  <div className="flex justify-end mt-3">
                    <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={handleTrainerAdd}>
                      <Plus className="text-white" />
                    </div>
                  </div>

                  <FieldArray name="section_empower.educators">
                    {(arrayHelpers) => {
                      trainersArrayRef.current = arrayHelpers;
                      return (
                        <div className="mt-2 overflow-x-auto">
                          <table className="w-full table-fixed border-collapse border border-gray-300">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="w-[30%] border font-normal border-gray-300 px-2 py-2 text-left">Label</th>
                                <th className="w-[30%] border font-normal border-gray-300 px-2 py-2 text-left">Count</th>
                                <th className="w-[30%] border font-normal border-gray-300 px-2 py-2 text-left">Suffix</th>

                                <th className="w-[30%] border font-normal border-gray-300 px-2 py-2 text-left">Logo Image</th>
                                <th className="w-[30%] border font-normal border-gray-300 px-2 py-2 text-left">Alt tag</th>
                                <th className="w-[10%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values?.section_empower?.educators?.map((item, index) => (
                                <tr key={index}>
                                  <td className="border border-gray-300 px-4 py-2">
                                    <FormikInput name={`section_empower.educators.${index}.label`} rootClassName="w-full" />
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2">
                                    <FormikInput name={`section_empower.educators.${index}.count`} rootClassName="w-full" />
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2">
                                    <FormikInput name={`section_empower.educators.${index}.suffix`} rootClassName="w-full" />
                                  </td>

                                  <td className="border px-2 py-2">
                                    <ImageUploader
                                      title="Image"
                                      imageUrl={item.image_link}
                                      onChange={(res) => setFieldValue(`section_empower.educators.${index}.image_link`, res?.data?.file_url)}
                                    />
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2">
                                    <FormikInput name={`section_empower.educators.${index}.alt_tag`} rootClassName="w-full" />
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2 text-center">
                                    <div className="flex justify-center cursor-pointer" onClick={handleTrainerDelete(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      );
                    }}
                  </FieldArray>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3" className="w-[100%] ml-[1rem]">
                <Accordion.Header>Section Beleives</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1  gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="section_beleives.heading" rootClassName="w-full" />
                    </div>
                  </div>

                  <div className="flex justify-end mt-3">
                    <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={handleBeliefAdd}>
                      <Plus className="text-white" />
                    </div>
                  </div>

                  <div className="mt-2 overflow-x-auto">
                    <FieldArray
                      name="section_beleives.believes"
                      render={(arrayHelpers) => {
                        believesArrayRef.current = arrayHelpers;

                        return (
                          <div className="space-y-6">
                            {values?.section_beleives?.believes?.map((item, index) => (
                              <table key={`believe-row-${index}`} className="w-full table-fixed border-collapse border border-gray-300">
                                <thead className="bg-gray-200">
                                  <tr>
                                    <th className="w-[31.33%] font-normal border px-2 py-2 text-left">Label</th>
                                    <th className="w-[31.33%] font-normal border px-2 py-2 text-left">Alt tag</th>
                                    <th className="w-[31.33%] font-normal border px-2 py-2 text-left">Image</th>
                                    <th className="w-[6%] font-normal border px-2 py-2 text-center">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <React.Fragment>
                                    <tr>
                                      <td className="border px-2 py-2">
                                        <FormikInput name={`section_beleives.believes.${index}.label`} rootClassName="w-full" />
                                      </td>
                                      <td className="border px-2 py-2">
                                        <FormikInput name={`section_beleives.believes.${index}.alt_tag`} rootClassName="w-full" />
                                      </td>
                                      <td className="border px-2 py-2">
                                        <ImageUploader
                                          title="Image"
                                          imageUrl={item.image_link}
                                          onChange={(res) => setFieldValue(`section_beleives.believes.${index}.image_link`, res?.data?.file_url)}
                                        />
                                      </td>
                                      <td className="border px-2 py-2 text-center" rowSpan={2}>
                                        <div className="flex justify-center items-center h-full cursor-pointer" onClick={handleBeliefDelete(index)}>
                                          <Trash />
                                        </div>
                                      </td>
                                    </tr>

                                    <tr>
                                      <td colSpan={3} className="border px-2 py-2">
                                        <label className="block text-gray-700 text-sm font-semibold mb-2">Description</label>
                                        <FormikTextarea name={`section_beleives.believes.${index}.description`} rootClassName="w-full" />
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                </tbody>
                              </table>
                            ))}
                          </div>
                        );
                      }}
                    />
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4" className="w-[100%] ml-[1rem]">
                <Accordion.Header>Our Story</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3 ">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="section_story.heading" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Alt Tag" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="section_story.alt_tag" rootClassName="w-full" />
                    </div>
                  </div>

                  <div className="flex flex-col mt-2">
                    <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                    <FormikTextarea name="section_story.description" as="textarea" rootClassName="w-full" />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3 ">
                    <div className="flex flex-col">
                      <Label label="Desktop Banner" className="mb-2 text-black text-[15px] font-semibold" />
                      <ImageUploader
                        className="w-full"
                        title="image"
                        name="section_story.banner.desktop_url"
                        imageUrl={values?.section_story?.banner?.desktop_url}
                        onChange={(res) => {
                          setFieldValue(`section_story.banner.desktop_url`, res?.data?.file_url);
                        }}
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Mobile Banner" className="mb-2 text-black text-[15px] font-semibold" />
                      <ImageUploader
                        className="w-full"
                        title="image"
                        name="section_story.banner.mobile_url"
                        imageUrl={values?.section_story?.banner?.mobile_url}
                        onChange={(res) => {
                          setFieldValue(`section_story.banner.mobile_url`, res?.data?.file_url);
                        }}
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="10" className="w-[100%] ml-[1rem] mb-8">
                <Accordion.Header>Testimonial Heading And FAQ's</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label label="Testimonial Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="testimonials.heading" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="FAQ Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="testimonials.faq_heading" rootClassName="w-full" />
                    </div>
                  </div>
                  <div className="flex justify-end mt-3">
                    <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={() => monialsRef?.current?.push({ faq: "" })}>
                      <Plus className="text-white" />
                    </div>
                  </div>

                  <FieldArray name="testimonials.testimonials">
                    {(arrayHelpers) => {
                      monialsRef.current = arrayHelpers;

                      return (
                        <div className="mt-2 overflow-x-auto">
                          <table className="w-full table-fixed border-collapse border border-gray-300">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="w-[94%] border font-normal border-gray-300 px-2 py-2 text-left">Faq</th>
                                <th className="w-[6%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values?.testimonials?.testimonials?.map((item, index) => (
                                <tr key={index}>
                                  <td className="border border-gray-300 px-4 py-2">
                                    <FormikDropdown
                                      options={getFaqQuery?.data?.data?.data?.map((item) => ({
                                        label: item.ques,
                                        value: item.id,
                                      }))}
                                      name={`testimonials.testimonials.${index}.faq`}
                                      rootClassName="w-full"
                                    />
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2 text-center">
                                    <div className="flex justify-center cursor-pointer" onClick={() => monialsRef?.current?.remove(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      );
                    }}
                  </FieldArray>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
